import Vue from "vue";
import Router from "vue-router";
// export const BASE_URL ='/csbdc/newtfw' ;
import global from "../components/global";
// import HelloWorld from '@/pages/HelloWorld'
// import HelloFromVux from '@/pages/HelloFromVux'
// import login from '@/pages/login'
// import sign from '@/pages/sign'
// import houseInfo from '@/pages/houseInfo'
// import selectHouse from '@/pages/selectHouse'

//核心代码
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);

const router = new Router({
  routes: [
    /*{
      path: '/',
      name: 'guide',
      component: resolve => require(['@/pages/guide/guide'],resolve),
    },*/
    {
      path: "/",
      name: "",
      component: resolve => require(["@/pages/homeTabber"], resolve),
      children: [
        {
          path: "",
          name: "home",
          component: resolve => require(["@/pages/guide/guide"], resolve)
        },
        {
          path: "me",
          name: "me",
          component: resolve => require(["@/pages/me"], resolve)
        },
        {
          path: "taofang",
          name: "taofang",
          component: resolve => require(["@/pages/home"], resolve)
        }
      ]
    },
    {
      path: "/main",
      name: "main",
      component: resolve => require(["@/pages/main"], resolve)
    },
    {
      path: "/estate",
      name: "estate",
      component: resolve => require(["@/pages/estate"], resolve)
    },
    {
      path: "/toSearchHouse",
      name: "toSearchHouse",
      component: resolve =>
        require(["@/pages/toSearchHouse/toSearchHouse"], resolve)
    },
    {
      path: "/demandDetail",
      name: "demandDetail",
      component: resolve =>
        require(["@/pages/toSearchHouse/demandDetail"], resolve)
    },
    {
      path: "/postDemand",
      name: "postDemand",
      component: resolve =>
        require(["@/pages/toSearchHouse/postDemand"], resolve)
    },
    {
      path: "/myPostDemand",
      name: "myPostDemand",
      component: resolve =>
        require(["@/pages/toSearchHouse/myPostDemand"], resolve)
    },

    {
      path: "/browsingHistory",
      name: "browsingHistory",
      component: resolve => require(["@/pages/browsingHistory"], resolve)
    },
    {
      path: "/purchaseEncyclopedia",
      name: "purchaseEncyclopedia",
      component: resolve => require(["@/pages/purchaseEncyclopedia"], resolve)
    },

    {
      path: "/questionList",
      name: "questionList",
      component: resolve => require(["@/pages/QA/questionList"], resolve)
    },
    {
      path: "/allQuestionList",
      name: "allQuestionList",
      component: resolve => require(["@/pages/QA/allQuestionList"], resolve)
    },
    {
      path: "/presentQuestion",
      name: "presentQuestion",
      component: resolve => require(["@/pages/QA/presentQuestion"], resolve)
    },
    {
      path: "/questionDetail",
      name: "questionDetail",
      component: resolve => require(["@/pages/QA/questionDetail"], resolve)
    },
    {
      path: "/searchNotice",
      name: "searchNotice",
      component: resolve =>
        require(["@/pages/infoSearch/searchNotice"], resolve)
    },
    {
      path: "/elNumpage",
      name: "elNumpage",
      component: resolve =>
        require(["@/pages/infoSearch/elNumpage"], resolve)
    },
    {
      path: "/proofVertify",
      name: "proofVertify",
      component: resolve => require(["@/pages/infoSearch/proofVertify"], resolve)
    },
    {
      path: "/searchChildrenVerify",
      name: "searchChildrenVerify",
      component: resolve =>
        require(["@/pages/infoSearch/searchChildrenVerify"], resolve)
    },
    {
      path: "/searchChildrenInfo",
      name: "searchChildrenInfo",
      component: resolve =>
        require(["@/pages/infoSearch/searchChildrenInfo"], resolve)
    },
    {
      path: "/searchChildren",
      name: "searchChildren",
      component: resolve =>
        require(["@/pages/infoSearch/searchChildren"], resolve)
    },
    {
      path: "/cancelTheAccount",
      name: "cancelTheAccount",
      component: resolve =>
        require(["@/pages/cancelTheAccount/cancelTheAccount"], resolve)
    },
    {
      path: "/searchInfo",
      name: "searchInfo",
      component: resolve =>
        require(["@/pages/infoSearch/searchInfo"], resolve)
    },
    {
      path: "/searchTypeSelect",
      name: "searchTypeSelect",
      component: resolve =>
        require(["@/pages/infoSearch/searchTypeSelect"], resolve)
    },
    {
      path: "/searchPDF",
      name: "searchPDF",
      component: resolve => require(["@/pages/infoSearch/searchPDF"], resolve)
    },
    {
      path: "/searchFace",
      name: "searchFace",
      component: resolve => require(["@/pages/infoSearch/searchFace"], resolve)
    },
    {
      path: "/appointFace",
      name: "appointFace",
      component: resolve => require(["@/pages/appointment/appointFace"], resolve)
    },
    {
      path: "/savePDFNotice",
      name: "savePDFNotice",
      component: resolve =>
        require(["@/pages/infoSearch/savePDFNotice"], resolve)
    },
    {
      path: "/numberingVerification",
      name: "numberingVerification",
      component: resolve =>
        require(["@/pages/infoSearch/numberingVerification"], resolve)
    },
    {
      path: "/infoAndNumbering",
      name: "infoAndNumbering",
      component: resolve =>
        require(["@/pages/infoSearch/infoAndNumbering"], resolve)
    },
    {
      path: "/financialServices",
      name: "financialServices",
      component: resolve =>
        require(["@/pages/infoSearch/financialServices"], resolve)
    },
    {
      path: "/certificationVerification",
      name: "certificationVerification",
      component: resolve =>
        require(["@/pages/infoSearch/certificationVerification"], resolve)
    },
    {
      path: "/handleList",
      name: "handleList",
      component: resolve => require(["@/pages/handleList"], resolve)
    },
    {
      path: "/handleDetail",
      name: "handleDetail",
      component: resolve => require(["@/pages/handleDetail"], resolve)
    },
    {
      path: "/newsList",
      name: "newsList",
      component: resolve => require(["@/pages/newsList"], resolve)
    },
    {
      path: "/newsDetail",
      name: "newsDetail",
      component: resolve => require(["@/pages/newsDetail"], resolve)
    },
    /*{
      path: '/homeTabber',
      name: '',
      component: resolve => require(['@/pages/homeTabber'], resolve),
      children: [
        {
          path: '',
          name: 'home',
          component: resolve => require(['@/pages/home'], resolve)
        },
        {
          path: 'me',
          name: 'me',
          component: resolve => require(['@/pages/me'], resolve)
        },
        {
          path: 'message',
          name: 'message',
          component: resolve => require(['@/pages/message'], resolve)
        },
      ]
    },*/

    {
      path: "/detail",
      name: "detail",
      component: resolve => require(["@/pages/detail"], resolve)
    },
    {
      path: "/zhongzhuan",
      name: "zhongzhuan",
      component: resolve => require(["@/pages/zhongzhuan"], resolve)
    },
    {
      path: "/smsVerification",
      name: "smsVerification",
      component: resolve => require(["@/pages/smsVerification"], resolve)
    },
    {
      path: "/houseStatus",
      name: "houseStatus",
      component: resolve => require(["@/pages/houseStatus"], resolve)
    },
    {
      path: "/secondHandHouse",
      name: "secondHandHouse",
      component: resolve => require(["@/pages/secondHandHouse"], resolve)
    },
    {
      path: "/secondHandHouseDetail",
      name: "secondHandHouseDetail",
      component: resolve => require(["@/pages/secondHandHouseDetail"], resolve)
    },
    {
      path: "/orderViewHouse",
      name: "orderViewHouse",
      component: resolve => require(["@/pages/orderViewHouse"], resolve)
    },
    {
      path: "/signOnline",
      name: "signOnline",
      component: resolve => require(["@/pages/signOnline"], resolve)
    },
    {
      path: "/search",
      name: "search",
      component: resolve => require(["@/pages/search"], resolve)
    },
    {
      path: "/searchResult",
      name: "searchResult",
      component: resolve => require(["@/pages/searchResult"], resolve)
    },
    {
      path: "/signup",
      name: "signup",
      component: resolve => require(["@/components/login/signup"], resolve)
    },
    {
      path: "/login",
      name: "login",
      component: resolve => require(["@/components/login/login"], resolve)
    },
    {
      path: "/inMap",
      name: "inMap",
      component: resolve => require(["@/pages/inMap"], resolve)
    },
    {
      path: "/personal",
      name: "personal",
      component: resolve => require(["@/pages/personal"], resolve)
    },
    {
      path: "/notice",
      name: "notice",
      component: resolve => require(["@/pages/notice"], resolve)
    },
    {
      path: "/publish",
      name: "publish",
      component: resolve => require(["@/pages/publish"], resolve)
    },
    {
      path: "/myWatch",
      name: "myWatch",
      component: resolve => require(["@/pages/myWatch"], resolve)
    },
    {
      path: "/attentionHouse",
      name: "attentionHouse",
      component: resolve => require(["@/pages/attentionHouse"], resolve)
    },
    {
      path: "/taxPayment",
      name: "taxPayment",
      component: resolve => require(["@/pages/taxPayment"], resolve)
    },
    {
      path: "/wxface",
      name: "wxface",
      component: resolve => require(["@/components/wxface/wxface"], resolve),
      children: [
        {
          path: "",
          name: "step1",
          component: resolve => require(["@/components/wxface/step1"], resolve)
        },
        {
          path: "/step2",
          name: "step2",
          component: resolve => require(["@/components/wxface/step2"], resolve)
        },
        {
          path: "/step3",
          name: "step3",
          component: resolve => require(["@/components/wxface/step3"], resolve)
        }
      ]
    },
    {
      path: "/newpublish",
      name: "newpublish",
      component: resolve => require(["@/pages/netSign/newpublish"], resolve)
    },
    {
      path: "/signStep1",
      name: "signStep1",
      component: resolve => require(["@/pages/netSign/step1"], resolve)
    },
    {
      path: "/signStep2",
      name: "signStep2",
      component: resolve => require(["@/pages/netSign/step2"], resolve)
    },
    {
      path: "/signStep3",
      name: "signStep3",
      component: resolve => require(["@/pages/netSign/step3"], resolve)
    },
    {
      path: "/signStep4",
      name: "signStep4",
      component: resolve => require(["@/pages/netSign/step4"], resolve)
    },
    {
      path: "/signStep5",
      name: "signStep5",
      component: resolve => require(["@/pages/netSign/step5"], resolve)
    },
    {
      path: "/sell",
      name: "sell",
      component: resolve => require(["@/pages/sell"], resolve)
    },
    {
      path: "/sellStep3",
      name: "sellStep3",
      component: resolve => require(["@/pages/sellRouter/sellStep3"], resolve)
    },
    {
      path: "/sellStep4",
      name: "sellStep4",
      component: resolve => require(["@/pages/sellRouter/sellStep4"], resolve)
    },
    {
      path: "/sellStep5",
      name: "sellStep5",
      component: resolve => require(["@/pages/sellRouter/sellStep5"], resolve)
    },
    {
      path: "/sellFaceAttest",
      name: "sellFaceAttest",
      component: resolve => require(["@/pages/sellRouter/faceAttest"], resolve)
    },
    {
      path: "/buyStep1",
      name: "buyStep1",
      component: resolve => require(["@/pages/buy/step1"], resolve)
    },
    {
      path: "/buyStep2",
      name: "buyStep2",
      component: resolve => require(["@/pages/buy/step2"], resolve)
    },
    {
      path: "/buyStep3",
      name: "buyStep3",
      component: resolve => require(["@/pages/buy/step3"], resolve)
    },
    {
      path: "/buyStep4",
      name: "buyStep4",
      component: resolve => require(["@/pages/buy/step4"], resolve)
    },
    {
      path: "/back",
      name: "back",
      component: resolve => require(["@/pages/buy/back"], resolve)
    },
    {
      path: "/buyNotice",
      name: "buyNotice",
      component: resolve => require(["@/pages/buy/notice"], resolve)
    },
    {
      path: "/contract",
      name: "contract",
      component: resolve => require(["@/pages/buy/contract"], resolve)
    },
    {
      path: "/result",
      name: "result",
      component: resolve => require(["@/pages/buy/result"], resolve)
    },
    {
      path: "/sellerStep1",
      name: "sellerStep1",
      component: resolve => require(["@/pages/seller/step1"], resolve)
    },
    {
      path: "/sellerStep2",
      name: "sellerStep2",
      component: resolve => require(["@/pages/seller/step2"], resolve)
    },
    {
      path: "/sellerStep3",
      name: "sellerStep3",
      component: resolve => require(["@/pages/seller/step3"], resolve)
    },
    {
      path: "/sellerStep4",
      name: "sellerStep4",
      component: resolve => require(["@/pages/seller/step4"], resolve)
    },
    {
      path: "/sellerback",
      name: "sellerback",
      component: resolve => require(["@/pages/seller/back"], resolve)
    },
    {
      path: "/sellerNotice",
      name: "sellerNotice",
      component: resolve => require(["@/pages/seller/notice"], resolve)
    },
    {
      path: "/sellerContract",
      name: "sellerContract",
      component: resolve => require(["@/pages/seller/contract"], resolve)
    },
    {
      path: "/sellerResult",
      name: "sellerResult",
      component: resolve => require(["@/pages/seller/result"], resolve)
    },

    {
      path: "/appointmentGuide",
      name: "appointmentGuide",
      component: resolve => require(["@/pages/appointment/guide"], resolve)
    },
    {
      path: "/appointmentNotice",
      name: "appointmentNotice",
      component: resolve => require(["@/pages/appointment/notice"], resolve)
    },
    {
      path: "/enterpriseAppointmentNotice",
      name: "enterpriseAppointmentNotice",
      component: resolve =>
        require(["@/pages/appointment/enterpriseNotice"], resolve)
    },
    {
      path: "/appointment",
      name: "appointment",
      component: resolve =>
        require(["@/pages/appointment/appointment"], resolve)
    },
    {
      path: "/enterpriseAppointment",
      name: "enterpriseAppointment",
      component: resolve =>
        require(["@/pages/appointment/enterpriseAppointment"], resolve)
    },
    {
      path: "/appointmentSuccessd",
      name: "appointmentSuccessd",
      component: resolve => require(["@/pages/appointment/successd"], resolve)
    },
    {
      path: "/enterpriseAppointmentSuccessd",
      name: "enterpriseAppointmentSuccessd",
      component: resolve =>
        require(["@/pages/appointment/enterpriseSuccessd"], resolve)
    },
    {
      path: "/appointmentConfirm",
      name: "appointmentConfirm",
      component: resolve => require(["@/pages/appointment/confirm"], resolve)
    },
    {
      path: "/enterpriseAppointmentConfirm",
      name: "enterpriseAppointmentConfirm",
      component: resolve =>
        require(["@/pages/appointment/enterpriseConfirm"], resolve)
    },

    {
      path: "/appointmentRecordDetail",
      name: "appointmentRecordDetail",
      component: resolve =>
        require(["@/pages/appointment/recordDetail"], resolve)
    },
    {
      path: "/appointmentSelect",
      name: "appointmentSelect",
      component: resolve => require(["@/pages/appointment/select"], resolve)
    },
    {
      path: "/appointmentSearchInfo",
      name: "appointmentSearchInfo",
      component: resolve => require(["@/pages/appointment/searchInfo"], resolve)
    },
    {
      path: "/progress",
      name: "progress",
      component: resolve => require(["@/pages/progress"], resolve)
    },
    {
      path: "/networkCard",
      name: "networkCard",
      component: resolve => require(["@/pages/networkCard/index"], resolve)
    },
    {
      path: "/networkCardNotice",
      name: "networkCardNotice",
      component: resolve => require(["@/pages/networkCard/notice"], resolve)
    },
    {
      path: "/cardList",
      name: "cardList",
      component: resolve => require(["@/pages/networkCard/cardList"], resolve)
    },
    {
      path: "/PDFView",
      name: "PDFView",
      component: resolve => require(["@/pages/networkCard/PDFView"], resolve)
    },
    {
      path: "/updatePhone",
      name: "updatePhone",
      component: resolve => require(["@/pages/updatePhone"], resolve)
    },
    {
      path: "/oldPhone",
      name: "oldPhone",
      component: resolve => require(["@/pages/oldPhone"], resolve)
    },
    {
      path: "/query",
      name: "query",
      component: resolve => require(["@/pages/query/index"], resolve),
      meta: {
        keepAlive: true // 不需要被缓存
      }
    },
    {
      path: "/query/details",
      name: "query-details",
      component: resolve => require(["@/pages/query/details"], resolve)
    },
    {
      path: "/checkCode",
      name: "check-code",
      component: resolve => require(["@/pages/checkCode"], resolve)
    },
    {
      path: "/zhzx",
      name: "zhzx",
      component: resolve => require(["@/pages/zhzx/zhzx"], resolve)
    },
    {
      path: "/viewzxxy",
      name: "viewzxxy",
      component: resolve => require(["@/pages/zhzx/zxxy"], resolve)
    },
    {
      path: "/zhzxFace",
      name: "zhzxFace",
      component: resolve => require(["@/pages/zhzx/zhzxFace"], resolve)
    },
    // 以图查房
    {
      path: "/mqh",
      name: "mqh",
      component: resolve => require(['@/pages/mapQueryHouse/map'], resolve),
    },
    // 使用须知
    {
      path: "/instructionsUser",
      name: "instructionsUser",
      component: resolve => require(['@/pages/mapQueryHouse/instructionsUser'], resolve),
    },
    // 区块链模块
    {
      path: "/blockchainQuery",
      name: "blockchainQuery",
      component: resolve => require(["@/pages/blockchain/blockchainQuery"], resolve)
    },
    {
      path: "/obligeeQuery",
      name: "obligeeQuery",
      component: resolve => require(["@/pages/blockchain/obligeeQuery"], resolve)
    },
    {
      path: "/interestedPartyQuery",
      name: "interestedPartyQuery",
      component: resolve => require(["@/pages/blockchain/interestedPartyQuery"], resolve)
    },
    // 夫妻
    {
      path: "/conjugalRelations",
      name: "conjugalRelations",
      component: resolve => require(["@/pages/blockchain/conjugalRelations"], resolve)
    },
    // 抵押
    {
      path: "/mortgagorRelations",
      name: "mortgagorRelations",
      component: resolve => require(["@/pages/blockchain/mortgagorRelations"], resolve)
    }
  ]
});
router.beforeEach((to, from, next) => {
  // to: Route: 即将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由
  // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。

  const nextRoute1 = [
    "attentionHouse",
    "myWatch",
    "buyStep1",
    "notice",
    "publish",
    "approve",
    "message",
    "sell",
    "me",
    "secondHandHouseDetail"
  ];
  const nextRoute = [
    "zhongzhuan",
    "login",
    "signup",
    "home",
    "secondHandHouse",
    "inMap",
    "secondHandHouseDetail",
    "search",
    "searchResult",
    "handleList",
    "handleDetail",
    "newsList",
    "newsDetail",
    "main",
    "guide",
    "taofang",
    "oldPhone",
    "updatePhone"
  ];
  let tokenTime = new Function(global.tokenTime);
  tokenTime();

  if (to.name == "home") {
    sessionStorage.setItem("active", 0);
  } else if (to.name == "taofang") {
    sessionStorage.setItem("active", 1);
  } else if (to.name == "me") {
    sessionStorage.setItem("active", 2);
  }
  let isLogin = localStorage.getItem("token");
  let isVerify = window.localStorage.getItem("isVerify");
  // 未登录状态；当路由到nextRoute指定页时，跳转至login
  if (nextRoute.indexOf(to.name) >= 0) {
    // next()
  } else {
    if (to.query.clientid) {
      window.sessionStorage.setItem("clientid", to.query.clientid);
      window.sessionStorage.setItem("timestamp", to.query.timestamp);
      window.sessionStorage.setItem("sign", to.query.sign);
      window.sessionStorage.setItem("key", to.query.key);
      if (to.query.houseid != undefined) {
        window.sessionStorage.setItem("houseid", to.query.houseid);
      }
    }
    if (!isLogin) {
      window.localStorage.setItem("toWhere", to.fullPath);
      if (global.loginRouter) {
        let loginRouter = new Function(global.loginRouter);
        loginRouter();
      } else {
        router.push({
          name: "signup"
        });
      }
      // window.location.replace(global.BASE_URL+'/wechat/login?returnUrl=/h5/index.html$/zhongzhuan');
      // router.push({ name: 'signup'})
    } else {
    }
  }

  // 已登录状态；当路由到login时，跳转至home
  if (to.name === "login") {
    if (isLogin) {
      router.push({
        name: "home"
      });
    }
  }
  //卖房模块,如未认证,跳转至认证

  // if (to.name === 'sell' || to.name === 'publish') {
  //   if (!isVerify) {
  //     router.push({name: 'step1'})
  //   }
  // }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js